import CodeEditor from "@/components/CodeEditor"

const HtmlField = ({ config, ...props }) => {
  const width = config.width || "100%"
  const height = config.height || "200px"

  return <CodeEditor
    language='html'
    width={width}
    height={height}
    className='border twy-border-base'
    {...props}
  />
}

export default HtmlField
